/**
 * 描述：省市县三级联动
 * 日期：2017-7-13
 * 作者：Bai Zhiming
 */
'use strict';
angular.module('provinceAndCitiesModule', [])
    .directive('provinceAndCities', ['$timeout', '$q', 'trsHttpService', function ($timeout, $q, trsHttpService) {

        return {
            restrict: 'E',
            replace: true,
            scope: {
                callback: '&',
                province: '=',
                city: '=',
                district: '='
            },
            templateUrl: './components/util/provincesAndCities/provinceAndCities_tpl.html',
            link: function (scope, elem, attrs) {
                initStatus();
                initData();
                scope.$watch('province', function (newV, oldV) {
                    if (oldV === undefined && newV !== undefined) {
                        initStatus();
                        initData();
                    }
                });

                /**
                 * [initStatus description] 初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    scope.status = {
                        provinceCopy: angular.copy(scope.province),
                        cityCopy: angular.copy(scope.city),
                        districtCopy: angular.copy(scope.district),
                        params: { // 用于请求地区县市，默认请求全国 
                            // serviceid: 'navigation',
                            // typeid: 'zyzx',
                            // modelid: 'base',
                            // typeName: 'area',
                            containParent: false,
                            level: 1,
                            channelName: -1,
                            parentId: 'area_001',
                            excludeId: -1
                        }
                    };
                    scope.data = {};

                }

                /**
                 * [initData description] 初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    getProvincesList().then(function () {
                        if (scope.province && scope.city && scope.district) {
                            for (var i = 0; i < scope.status.provincesList.length; i++) {
                                if (scope.status.provincesList[i].dictName.indexOf(scope.status.provinceCopy) !== -1) {
                                    scope.status.selectedProvince = scope.status.provincesList[i];
                                    scope.province = scope.status.selectedProvince.dictName;
                                    break;
                                }
                            }
                            getCitiesList().then(function () {
                                for (var j = 0; j < scope.status.citiesList.length; j++) {
                                    if (scope.status.citiesList[j].dictName.indexOf(scope.status.cityCopy) !== -1) {
                                        scope.status.selectedCity = scope.status.citiesList[j];
                                        scope.city = scope.status.selectedCity.dictName;
                                        break;
                                    }
                                }
                                getDistrict().then(function () {
                                    for (var k = 0; k < scope.status.districtList.length; k++) {
                                        if (scope.status.districtList[k].dictName.indexOf(scope.status.districtCopy) !== -1) {
                                            scope.status.selectDistrict = scope.status.districtList[k];
                                            scope.district = scope.status.selectDistrict.dictName;
                                            break;
                                        }
                                    }
                                });
                            });
                        } else {
                            getCitiesList().then(function () {
                                if (scope.status.selectedCity.hasChildren === 'true') {
                                    getDistrict();
                                }
                            });
                            // scope.callback();
                        }
                    });
                }

                /**
                 * [getProvincesList description] 获得省份列表
                 * @return  {[type]}  [return description]
                 */
                function getProvincesList() {
                    var deffer = $q.defer();
                    trsHttpService.httpServer('/dicttool/mcb_dicttool/area/getNaviTree', scope.status.params, 'post')
                        .then(function (data) {
                            scope.status.provincesList = data;
                            scope.status.selectedProvince = angular.copy(scope.status.provincesList[0]);
                            scope.province = scope.status.selectedProvince.dictName;
                            scope.optionp = scope.province;
                            deffer.resolve();
                        });
                    return deffer.promise;
                }

                /**
                 * [getCitiesList description] 获取省份下的市
                 * @return  {[type]}  [return description]
                 */
                function getCitiesList() {
                    var defer = $q.defer();
                    scope.status.params.parentId = scope.status.selectedProvince.id;
                    trsHttpService.httpServer('/dicttool/mcb_dicttool/area/getNaviTree', scope.status.params, 'post')
                        .then(function (data) {
                            if (data[0].hasChildren === 'true') { // 如果有下一级则去请求区县
                                scope.status.citiesList = angular.copy(data);
                                scope.status.selectedCity = angular.copy(data[0]);
                                scope.city = scope.status.selectedCity.dictName;
                                scope.optionc = scope.city;
                                defer.resolve(true);
                            } else {
                                scope.status.districtList = data;
                                scope.status.selectDistrict = angular.copy(scope.status.districtList[0]); // 暂且改为第一个
                                scope.district = scope.status.selectDistrict.dictName;
                                scope.optiond = scope.district;
                                for (var i = 1; i < data.length; i++) { // 循环市级数据，如果全部没有下一级，则是区县
                                    if (data[i].hasChildren === 'true') {
                                        scope.status.citiesList = angular.copy(data);
                                        scope.status.selectedCity = angular.copy(data[0]);
                                        scope.city = scope.status.selectedCity.dictName;
                                        scope.optionc = scope.city;
                                        return;
                                    }
                                }
                                scope.status.citiesList = angular.copy([scope.status.selectedProvince]);
                                scope.status.selectedCity = angular.copy(scope.status.selectedProvince);
                                scope.city = scope.status.selectedCity.dictName;
                                scope.optionc = scope.city;
                                defer.resolve(false);
                            }
                        });
                    return defer.promise;
                }

                /**
                 * [getDistrict description] 获取市下面的区县
                 * @return  {[type]}  [return description]
                 */
                function getDistrict() {
                    var defer = $q.defer();
                    scope.status.params.parentId = scope.status.selectedCity.id;
                    trsHttpService.httpServer('/dicttool/mcb_dicttool/area/getNaviTree', scope.status.params, 'post')
                        .then(function (data) {
                            scope.status.districtList = data;
                            scope.status.selectDistrict = angular.copy(scope.status.districtList[0]); // 暂且改为第一个
                            scope.district = scope.status.selectDistrict.dictName;
                            scope.optiond = scope.district;
                            defer.resolve();
                        });
                    return defer.promise;
                }
                scope.selectProvince = function () {
                    scope.province = scope.status.selectedProvince.dictName;
                    getCitiesList().then(function (flag) {
                        if (flag) {
                            getDistrict().then(function () {
                                scope.callback();
                            });
                        } else {
                            scope.callback();
                        }
                    });
                };
                scope.selectCity = function () {
                    if (scope.status.selectedCity.hasChildren === 'true') {
                        getDistrict().then(function () {
                            scope.callback();
                        });
                        scope.city = scope.status.selectedCity.dictName;
                    } else {
                        scope.status.districtList = angular.copy([scope.status.selectedCity]);
                        scope.status.selectDistrict = angular.copy(scope.status.districtList[0]); // 暂且改为第一个
                        scope.district = scope.status.selectDistrict.dictName;
                        scope.optiond = scope.district;
                        scope.callback();
                    }
                };
                scope.selectDistrict = function () {
                    scope.callback();
                    scope.district = scope.status.selectDistrict.dictName;
                };

            }
        };
    }]);
